import { useEffect } from 'react';
import { useAuth } from '@/auth/useAuth';
import { setAppBadge } from '@/push/badge';
import { usePushAutoRegister } from '@/push/usePush';
import { useTaskLoginNotice } from './useTaskLoginNotice';
import { useOpenTaskCount, useTasksRealtime } from './useTasksData';

/**
 * Mounted once inside the authenticated shell: the `tasks` realtime subscription, the prototype login notice,
 * Web Push registration for the signed-in login and the PWA app badge (task.md §4.8).
 */
export function TasksSessionEffects() {
  const { profile } = useAuth();
  useTasksRealtime(profile !== null);
  useTaskLoginNotice();
  usePushAutoRegister(profile?.id ?? null);
  const open = useOpenTaskCount();
  useEffect(() => {
    void setAppBadge(open);
  }, [open]);
  useEffect(
    () => () => {
      void setAppBadge(0);
    },
    [],
  );
  return null;
}
